/* eslint-disable import/prefer-default-export */

import config from '../../config';

const resources = {
  EMPLOYEES_DESCRIPTION: `${config.http.BASE_URL}/beautify/employees/description`,
  PROJECT_RESPONSIBILITIES: `${config.http.BASE_URL}/beautify/projects/responsibilities`,
  PROJECT_DESCRIPTION: `${config.http.BASE_URL}/beautify/projects/description`,
};

function createRequestOptions(body = {}) {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  };
}

function postRequest(resource, params) {
  const requestOptions = createRequestOptions(params);
  const url = resource;
  return fetch(url, requestOptions).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
}

/**
 *
 * @param {object} description
 * @returns {Promise}
 */
export function beautifyEmployeeDescription({ name, level, position, years, description }) {
  return postRequest(resources.EMPLOYEES_DESCRIPTION, {
    name,
    level,
    position,
    years,
    description,
  });
}

/**
 *
 * @param {string} responsibilities
 * @returns {Promise}
 */
export function beautifyProjectResponsibilities(responsibilities) {
  return postRequest(resources.PROJECT_RESPONSIBILITIES, { responsibilities });
}

/**
 *
 * @param {string} description
 * @returns {Promise}
 */
export function beautifyProjectDescription(description) {
  return postRequest(resources.PROJECT_DESCRIPTION, { description });
}
